import { atom } from 'recoil'
import { ISelectOption } from 'select_with_global_state/ISelect'

const CitiesRecoilState = atom<ISelectOption[] | null>({
  key: 'citiesRecoilState',
  default: null,
})

export { CitiesRecoilState }
